export default function lazyLoadComponents() {
  const reactNodes = window.document.querySelectorAll('[data-react-class]');

  if (reactNodes.length) {
    import('application/setup_components').then(({ setupComponents: setupComponents }) => {
      setupComponents();
    });
  }
}
